import { createStyles } from '@material-ui/core/styles';
import { makeStyles, Theme } from '@material-ui/core';

export const stylesBase = (theme: Theme) =>
  createStyles({
    nav: {
      '& $nav': {
        '& li:not(:last-of-type)': {
          marginRight: 60,
          border: '1px solird red',
        },
      },
    },
    main: {
      '& $nav': {
        '& li:not(:last-of-type)': {
          marginRight: 60,
          border: '1px solird red',
        },
      },
      '& $link': {
        textDecoration: 'none',
        color: theme.palette.text.secondary,
        ...theme.typography.h3,
        fontWeight: '600',
      },
      '& $linkActive': {
        color: theme.palette.accent.main,
      },
    },
    sub: {
      '& $nav': {
        '& li:not(:last-of-type)': {
          marginRight: 130,
        },
      },
      '& $link': {
        color: theme.palette.logo.main,
        textDecoration: 'none',
        display: 'block',
        padding: '13px 0px',
        ...theme.typography.h5,
        fontWeight: 400,
      },
      '& $linkActive': {
        position: 'relative',
        '&::after': {
          position: 'absolute',
          content: "''",
          width: '100%',
          height: 2,
          left: 0,
          right: 0,
          bottom: -1,
          backgroundColor: theme.palette.secondary.main,
          borderRadius: 8,
        },
      },

      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        position: 'absolute',
        width: '100%',
        left: 0,
        justifyContent: 'center',
        height: 50,
        bottom: -51,
        zIndex: 0,
        padding: '0 14px',
        backgroundColor: theme.palette.common.white,
        boxShadow: '0px 7px 13px rgb(227 228 236 / 55%);',
      },
    },
    subCompliance: {
      '& $nav': {
        '& li:not(:last-of-type)': {
          marginRight: 130,
        },
      },
      '& $link': {
        color: theme.palette.logo.main,
        textDecoration: 'none',
        display: 'block',
        padding: '13px 0px',
        ...theme.typography.h5,
        fontWeight: 400,
      },
      '& $linkActive': {
        position: 'relative',
        '&::after': {
          position: 'absolute',
          content: "''",
          width: '100%',
          height: 2,
          left: 0,
          right: 0,
          bottom: -1,
          backgroundColor: theme.palette.secondary.main,
          borderRadius: 8,
        },
        color: '#6769E0 !important',
        backgroundColor: 'rgb(113, 114, 166, 0.20) !important',
        borderColor: 'rgb(113, 114, 166, 0.45) !important',
      },

      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        position: 'absolute',
        width: '100%',
        left: 0,
        justifyContent: 'center',
        height: 50,
        bottom: -51,
        zIndex: 0,
        padding: '0 14px',
        backgroundColor: theme.palette.common.white,
        boxShadow: '0px 7px 13px rgb(227 228 236 / 55%);',
      },
    },
    link: {
      display: 'flex',
      textAlign: 'center',
      color: theme.palette.link.default,
      padding: '15px 16px',
      textDecoration: 'none',
      fontSize: 14,
      fontFamily: 'SBSansText-Regular',
      fontWeight: 500,
      borderRadius: 12,
      '& svg': {
        width: 15,
        height: 16,
        marginLeft: 3,
      },
      '&:hover': {
        color: theme.palette.link.hover,
        transition: 'color 0.3s ease',
      },
      '&:active': {
        color: theme.palette.link.active,
        transition: 'color 0.3s ease',
      },
    },
    linkActive: {
      color: theme.palette.link.active,
      backgroundColor: '#F1F5F9',
    },
    header: {
      overflowY: 'auto',
      padding: ({ matchesTablet }: { matchesTablet?: boolean }) => (matchesTablet ? 0 : `${theme.spacing(4)}px 20px`),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      '&::-webkit-scrollbar': {
        width: 3,
      },
    },
    userBox: {
      display: 'flex',
    },
    navbar: {
      maxWidth: 228,
      transition: 'all 0.1s ease-in-out',
    },
    collapsed: {
      transition: 'all 0.1s ease-in-out',
      width: 57,
    },
    list: {
      marginBottom: 16,
      '& li:last-child': {
        '&::after': {
          content: "''",
          borderBottom: '1px solid #E8E8E8',
          display: 'block',
          position: 'relative',
          top: 8,
        },
      },
    },
    empty: {},
    info: {
      marginTop: 'auto',
      paddingTop: '16px',
    },
  });

export const headerMenuBaseUseStyles = makeStyles(theme => ({
  ...stylesBase(theme),
}));
